import { render } from "./PreviewImageGroup.vue?vue&type=template&id=dfab0f74"
import script from "./PreviewImageGroup.vue?vue&type=script&lang=js"
export * from "./PreviewImageGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__